export default __webpack_public_path__ + "static/media/destination-type.d9a49900.svg";